const PREFIX = 'st.';
export const storage = {
  get(key: string): string | null { try { return localStorage.getItem(PREFIX + key); } catch { return null; } },
  set(key: string, value: string) { try { localStorage.setItem(PREFIX + key, value); } catch { /* usable without storage */ } },
  remove(key: string) { try { localStorage.removeItem(PREFIX + key); } catch { /* optional storage */ } },
  reset() { try { Object.keys(localStorage).filter(key => key.startsWith(PREFIX)).forEach(key => localStorage.removeItem(key)); } catch { /* optional storage */ } },
};
